import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export const TEXTOS = {
  titulo: "Tu página de reservas", comparte: "Comparte este enlace para que tus pacientes reserven solos.",
  inactiva: "Tu página se activa cuando tengas al menos un profesional con un servicio y su horario.",
  copiar: "Copiar enlace", abrir: "Abrir", copiado: "Enlace copiado", errorCopiar: "No se pudo copiar el enlace.",
  error: "No se pudo cargar el enlace.", reintentar: "Reintentar",
};

export default function ReservasPublicasCard() {
  const { activeClinic, user } = useAuth();
  const esDemo = !!user?.is_demo_session;
  const [estado, setEstado] = useState(null);
  const [mensaje, setMensaje] = useState("");
  const [intento, setIntento] = useState(0);
  useEffect(() => {
    if (esDemo) return;
    let vivo = true;
    setEstado(null); setMensaje("");
    api.get("/reservas/mi-enlace").then(({ data }) => { if (vivo) setEstado(data); })
      .catch((e) => { if (vivo && e?.response?.status !== 404) setEstado({ error: true }); });
    return () => { vivo = false; };
  }, [activeClinic?.id, intento, esDemo]);
  if (esDemo || !estado) return null;
  const copiar = async () => {
    try { await navigator.clipboard.writeText(estado.url); setMensaje(TEXTOS.copiado); }
    catch { setMensaje(TEXTOS.errorCopiar); }
  };
  return <section className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3" aria-label={TEXTOS.titulo}>
    <h2 className="font-display font-semibold">{TEXTOS.titulo}</h2>
    {estado.error ? <><p role="alert">{TEXTOS.error}</p><button onClick={() => setIntento((n) => n + 1)}>{TEXTOS.reintentar}</button></> : <>
      <p>{TEXTOS.comparte}</p>
      {!estado.disponible && <p>{TEXTOS.inactiva}</p>}
      <p className="break-all text-sm">{estado.url}</p>
      <div className="flex flex-wrap gap-4"><button onClick={copiar}>{TEXTOS.copiar}</button><a href={estado.url} target="_blank" rel="noreferrer">{TEXTOS.abrir}</a></div>
      {mensaje && <p role="status">{mensaje}</p>}
    </>}
  </section>;
}
